/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const LIKEFEED= createAsyncThunk(
  "likeFeed/likeFeed",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const likeFeedSlice = createSlice({
  name: "likeFeedSlice",
  initialState: {
    likeFeed: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOflikeFeed: (state) => {
        state.likeFeed.loading = false
        state.likeFeed.error = false
        state.likeFeed.data = []
        state.likeFeed.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(LIKEFEED.fulfilled, (state, action) => {
      state.likeFeed = {
        ...state.likeFeed,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LIKEFEED.pending, (state, action) => {
      state.likeFeed = {
        ...state.likeFeed,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LIKEFEED.rejected, (state, action) => {
      state.likeFeed = {
        ...state.likeFeed,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const likeFeedAction = {
    LIKEFEED,
};

export { likeFeedAction };
export default likeFeedSlice.reducer;
export const {setInitialStateOflikeFeed} = likeFeedSlice.actions